import { ROUTES } from 'constants/Route.constants'
import { useContactAndChannelBrowsersEnabled } from 'features/feature-flags/FeatureFlag.hooks'
import React, { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

interface HasChildren {
  children: ReactNode
}

interface FeatureFlagRedirectProps extends HasChildren {
  enabled: boolean
}

export function FeatureFlagRedirect({ children, enabled }: FeatureFlagRedirectProps) {
  return <>{enabled ? children : <Navigate to={ROUTES.WORKSPACE_LANDING_REDIRECT} replace />}</>
}

export function ContactAndChannelBrowsersFeatureFlagRedirect({ children }: HasChildren) {
  const CONTACT_AND_CHANNEL_BROWSERS_ENABLED = useContactAndChannelBrowsersEnabled()
  return <FeatureFlagRedirect enabled={CONTACT_AND_CHANNEL_BROWSERS_ENABLED}>{children}</FeatureFlagRedirect>
}
